import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22aa3888"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex font-montserrat justify-center items-center relative min-w-screen min-h-screen py-[50px] px-[10px] bg-gray-50" }
const _hoisted_2 = { class: "flex justify-center items-center z-30 flex-col fixed top-[40px] left-[50%] w-full translate-x-[-50%]" }
const _hoisted_3 = {
  key: 0,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[550px] w-[90%] p-[20px]"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-green-600 border border-green-600 my-[10px] text-white text-center font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_5 = { class: "w-full flex flex-col justify-center items-center relative py-[50px] md:px-[20px] px-[10px] max-w-[600px] border-2 border-gray-300 h-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-1xl mb-[20px] text-center font-bold" }, "Add a user", -1))
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "py-[10px] w-full px-[10px] relative" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "text-sm font-bold left-[20px] text-black-500 absolute top-[12px]"
}, "Firstname", -1))
const _hoisted_10 = { class: "py-[10px] w-full px-[10px] relative" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "text-sm font-bold left-[20px] text-black-500 absolute top-[12px]"
}, "Lastname", -1))
const _hoisted_12 = { class: "py-[10px] w-full px-[10px] relative" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "text-sm font-bold left-[20px] text-black-500 absolute top-[12px]"
}, "Username", -1))
const _hoisted_14 = { class: "py-[10px] w-full px-[10px] relative" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "text-sm font-bold left-[20px] text-black-500 absolute top-[12px]"
}, "Number", -1))
const _hoisted_16 = { class: "py-[10px] w-full px-[10px] relative" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "text-sm font-bold left-[20px] text-black-500 absolute top-[12px]"
}, "Email", -1))
const _hoisted_18 = { class: "py-[10px] w-full px-[10px] flex justify-end items-center relative" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-400 py-[50px] bg-gray-50 flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1))

import axios from 'axios';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axiosInstance from '@/plugins/axios';

const MIN_PASSWORD_LENGTH = 8;


export default /*#__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const pageTitle = ref('Register'); 
const showPassword = ref(false);
const cshowPassword = ref(false);
const successMessage = ref('');
const router = useRouter();

onMounted(() => {
  document.title = pageTitle.value; 
});

const userData = ref({
  firstname: '',
  lastname: '',
  username: '',
  phone: '',
  email: '',
});

const userForm = ref(); 
const loading = ref(false);
const errorMessage = ref('');

const isPasswordValid = (password: any) => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return passwordRegex.test(password);
};


const registerUser = async () => {
  try {
    loading.value = true;
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }
    //const { password, re_password } = userData.value;

    //if (password !== re_password) {
    //  errorMessage.value = 'Passwords do not match.';
    //  hideErrorMessageAfterDelay();
    //  return;
    //}
//
    //if (!isPasswordValid(password)) {
    //  errorMessage.value = 'Password should contain at least 8 characters with uppercase, lowercase, numbers, and special characters.';
    //  hideErrorMessageAfterDelay();
    //  return;
    //}

    const response = await axiosInstance.post('/auth/users/', userData.value, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      successMessage.value = `New user created successfully.`;
      hideSuccessMessageAfterDelay();
      userForm.value.reset();
      setTimeout(() => {
        router.push('/users');
      }, 5000);
    } else {
      console.error('Error creating user:', response.data);
      errorMessage.value = 'Error creating user.';
      hideErrorMessageAfterDelay();
    }
  } catch (error: any) {
    if (error.response) {

        console.error('Error response:', error.response.data);
      
        const errorData = error.response.data;
        const phoneError = errorData.phone ? errorData.phone[0] : '';
        const emailError = errorData.email ? errorData.email[0] : '';
        const passwordError = errorData.password ? errorData.password[0] : '';
        const rePasswordError = errorData.re_password ? errorData.re_password[0] : '';
      
        errorMessage.value = `Phone: ${phoneError}, Email: ${emailError}, Password: ${passwordError}, Re-enter Password: ${rePasswordError}`;
        hideErrorMessageAfterDelay();
      } else if (error.request) {
        console.error('No response received:', error.request);
        errorMessage.value = 'Erreur de connexion au serveur. Veuillez réessayer.';
        hideErrorMessageAfterDelay();
      } else {
        console.error('Unexpected error:', error.message);
        errorMessage.value = 'Une erreur inattendue s\'est produite. Veuillez réessayer.';
        hideErrorMessageAfterDelay();
      }
    }finally {
        loading.value = false;
      }
};

const hideSuccessMessageAfterDelay = () => {
  setTimeout(() => {
    successMessage.value = ''; 
  }, 5000);
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 10000);
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        (successMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(successMessage.value), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("form", {
          class: "flex flex-col justify-center items-center w-full relative max-w-[700px]",
          onSubmit: _withModifiers(registerUser, ["prevent"]),
          ref_key: "userForm",
          ref: userForm
        }, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "firstname",
              id: "firstname",
              class: "p-[10px] w-full rounded-[5px] border outline-none pt-[25px] bg-transparent",
              required: "",
              placeholder: "First Name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userData.value.firstname) = $event))
            }, null, 512), [
              [_vModelText, userData.value.firstname]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "lastname",
              id: "lastname",
              class: "p-[10px] w-full rounded-[5px] border outline-none pt-[25px] bg-transparent",
              required: "",
              placeholder: "Last Name",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userData.value.lastname) = $event))
            }, null, 512), [
              [_vModelText, userData.value.lastname]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "username",
              id: "username",
              class: "p-[10px] w-full rounded-[5px] border outline-none pt-[25px] bg-transparent",
              required: "",
              placeholder: "Username",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userData.value.username) = $event))
            }, null, 512), [
              [_vModelText, userData.value.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "phone",
              id: "phone",
              class: "p-[10px] w-full rounded-[5px] border outline-none pt-[25px] bg-transparent",
              required: "",
              placeholder: "Number",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userData.value.phone) = $event))
            }, null, 512), [
              [_vModelText, userData.value.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "email",
              id: "email",
              class: "p-[10px] w-full rounded-[5px] border outline-none pt-[25px] bg-transparent",
              required: "",
              placeholder: "ironsecur@gmail.com",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userData.value.email) = $event))
            }, null, 512), [
              [_vModelText, userData.value.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              type: "submit",
              disabled: loading.value,
              class: "py-[10px] min-w-[100px] px-[20px] rounded-[5px] text-sm font-bold text-white bg-cyan-500 hover:bg-cyan-600 duration-300"
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                : (_openBlock(), _createElementBlock("span", _hoisted_21, "Register"))
            ], 8, _hoisted_19)
          ])
        ], 40, _hoisted_7)
      ])
    ]),
    _hoisted_22
  ], 64))
}
}

})